interface RedirectData {
  studentProjectId: string;
  studentPlatformId: string;
  studyGroup: string;
  text: string;
  sessionId: string;
  token: string;
  onlyInfo?: boolean;
}

const redirectToChatbotEditor = (redirectData: RedirectData) => {
  const { studentProjectId, studentPlatformId, studyGroup, text, sessionId, token, onlyInfo } =
    redirectData;

  const url = new URLSearchParams();
  url.append('token', token);
  url.append('session_id', sessionId);
  url.append('student_project_id', studentProjectId);
  url.append('platform_id', studentPlatformId);
  url.append('study_group', studyGroup);
  url.append('text', text);
  if (onlyInfo) {
    url.append('only_info', 'true');
  }

  const editorBase = window.location.hostname === 'localhost'
    ? 'http://localhost:3000/editor'
    : 'https://editor.stemi.education';

  return `${editorBase}?${url}`;
};

export default redirectToChatbotEditor;
